import { Expression } from "./abstract.expression";

export class SelectExpression extends Expression 
{
    constructor(private readonly properties: string[]) 
    {
        super();
    }

    toQuery(): string 
    {
        return `$select=${this.properties.join(",")}`;
    }
}
